/** Falla de carga de la pantalla del vendedor: monolito o BFF no disponibles (se puede reintentar). */
export const ErrorDeCarga = () => (
  // Sin alto de toda la ventana: App.tsx reparte el alto y el pie queda a la vista.
  <div className="container d-flex justify-content-center align-items-center py-5" style={{ minHeight: '50vh' }}>
    <div className="col-12 col-md-6 text-center">
      <h4>No pudimos cargar el cotizador</h4>
      <p className="text-muted">Revisá la conexión y probá de nuevo en unos segundos.</p>
      <button type="button" className="btn btn-primary px-4" onClick={() => window.location.reload()}>
        Reintentar
      </button>
    </div>
  </div>
);
